/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:35
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-04 16:13:17
 */
import template from './template.html';

/* 
  Nếu muốn có divier trong select thì option đó thêm attribute: data-type="group"
*/

/**
 * DropdownControl
 */
export default class DropdownControl {
  $input: JQuery;
  $wrapper: JQuery;
  options: any;
  $html: JQuery;
  name: string;
  flagDisabled = false;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this.$input = $input;
    this.$wrapper = $input.parent();
    this.options = options;
    this.renderTemplate();
    this.name = $input.attr('name') || '';
  }

  /**
   * Render Select to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    this.$input.hide();
    const options = this.$input.find('option');
    const html = template(options);
    this.$html = $(html);

    // Toggle click dropdown select animations
    this.$html.off('click.dropdown-select').on('click.dropdown-select', function () {
      if (_this.flagDisabled) {
        return;
      }

      $(this).find('.gf-dropdown-list').toggle();
      const visible = $(this).find('.gf-dropdown-list').is(':visible');
      if (visible) {
        if (_this.options && _this.options.onOpened) {
          _this.options.onOpened();
        }
      } else {
        if (_this.options && _this.options.onClosed) {
          _this.options.onClosed();
        }
      }
    });

    // Click outside
    jQuery(window).on('click.outside', function (event) {
      if (!$(event.target).closest(_this.$html).length && !$(event.target).is(_this.$html)) {
        _this.$wrapper.find('.gf-dropdown-list').hide();
        if (_this.options && _this.options.onClosed) {
          _this.options.onClosed();
        }
      }
    });

    this.$html
      .find('.gf-dropdown-item')
      .off('click')
      .on('click', function () {
        if (_this.flagDisabled) {
          return;
        }
        const value = $(this).data('value') || '';
        const text = $(this).text() || '';

        const data = {
          name: _this.name,
          value: value,
          text: text,
        };

        _this.setValue(value);

        if (_this.options && _this.options.onChange) {
          _this.options.onChange(data);
        }
      });

    (this.$html.find('.gf-dropdown-list').addClass('optiscroll') as any).optiscroll();
    this.$input.after(this.$html);
  }

  /**
   * Set value to select
   * @param val ..
   * @returns void
   */
  setValue(val: string | number): void {
    this.$input.val(val);
    this.$html.find('.gf-dropdown-selected p').text(this.$input.find('option:selected').text());
    // Clear default then set again
    this.$html.find('.gf-dropdown-item').removeClass('gf-dropdown-item-selected');
    this.$html.find(`.gf-dropdown-item[data-value=${val}]`).addClass('gf-dropdown-item-selected');
  }

  /**
   * disabled
   */
  disable(): void {
    this.flagDisabled = true;
    this.$html.attr('disabled', 'disabled');
  }

  /**
   * enabled
   */
  enable(): void {
    this.flagDisabled = false;
    this.$html.removeAttr('disabled');
  }

  /**
   * toggleDisabled
   */
  toggleDisable(): void {
    if (this.flagDisabled) {
      //current is disabled => enabled
      this.enable();
    } else {
      this.disable();
    }
  }
}
